import { render, staticRenderFns } from "./DotLoader.vue?vue&type=template&id=5392ab30&scoped=true&"
import script from "./DotLoader.vue?vue&type=script&lang=ts&"
export * from "./DotLoader.vue?vue&type=script&lang=ts&"
import style0 from "./DotLoader.vue?vue&type=style&index=0&id=5392ab30&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5392ab30",
  null
  
)

export default component.exports